import type { LocationSchema } from '@libs/data-access/entities'
import type { ShiftMeal } from '@libs/data-access/queries'

import type { MealValue } from '../components/MealRow/MealRow'

type Props = {
  meals?: {
    value: MealValue
  }[]
  weeklyscheduleLocation: LocationSchema
  shiftMeals: ShiftMeal[]
}
/**
 * Retreive all the meals from the form and compute if we need to add those or delete them from the DB
 */
const getMealsToSend = ({
  meals,
  weeklyscheduleLocation,
  shiftMeals
}: Props) => {
  const mealsToAdd = meals?.map(({ value: mealData }) => ({
    id: typeof mealData.id === 'number' ? mealData.id : null,
    planned_meal_type:
      mealData.meal?.value || weeklyscheduleLocation?.default_meal_type,
    real_meal_type:
      mealData.meal?.value || weeklyscheduleLocation?.default_meal_type
  }))

  const mealsToDelete = shiftMeals?.map(mealItem => {
    const mealId = mealItem.id

    const keepMeal = mealsToAdd?.find(newMeal => {
      return newMeal.id && newMeal.id === mealId
    })

    if (!keepMeal) {
      return { id: mealId, _destroy: 1 }
    }

    return null
  })

  return mealsToAdd
    ? [...mealsToAdd, ...mealsToDelete.filter(Boolean)]
    : mealsToDelete.filter(Boolean)
}

export default getMealsToSend
